import type { ForYouConfig } from '@atlassian/global-side-navigation';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';

export const getForYouConfig = functionWithCondition(
	() => fg('navx-1830-for-you-config-refactor'),
	getForYouConfigNew,
	getForYouConfigOld,
);

function getForYouConfigNew(): ForYouConfig {
	return {};
}

function getForYouConfigOld(): ForYouConfig {
	return {
		hideForYou: true,
		hideRecents: true,
		hideStarred: true,
	};
}
